import { render, staticRenderFns } from "./FieldsModule.vue?vue&type=template&id=9ac149e4&scoped=true"
import script from "./FieldsModule.vue?vue&type=script&lang=js"
export * from "./FieldsModule.vue?vue&type=script&lang=js"
import style0 from "./FieldsModule.vue?vue&type=style&index=0&id=9ac149e4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac149e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ac149e4')) {
      api.createRecord('9ac149e4', component.options)
    } else {
      api.reload('9ac149e4', component.options)
    }
    module.hot.accept("./FieldsModule.vue?vue&type=template&id=9ac149e4&scoped=true", function () {
      api.rerender('9ac149e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/FieldsModule.vue"
export default component.exports